import { APP_VERSION } from '../../lib/version'

export function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="mt-10 pt-6 pb-8 border-t border-orange-200 text-center text-sm text-gray-600">
      <div className="container mx-auto px-4">
        <div className="mb-4">
          <div>© {currentYear} Alexander Di Bernardo - Alle Rechte vorbehalten</div>
          <div className="mt-1">MVS-Rechner v{APP_VERSION} basierend auf dem Österreichischen Versicherungssteuergesetz</div>
        </div>
        <div className="flex justify-center space-x-6">
          <a href="#impressum" className="text-orange-700 hover:text-orange-900 transition-colors">
            Impressum
          </a>
          <a href="#datenschutz" className="text-orange-700 hover:text-orange-900 transition-colors">
            Datenschutz
          </a>
        </div>
      </div>
    </footer>
  )
}

